import { useEffect, useState } from "react";
import { getMemberToken, memberApi } from "./memberSession";
import { hasEntitledFeature } from "./entitlement";

// What this workspace's plan includes. Served by /admin/settings/licence, which answers
// for both deployment types: a hosted workspace reports the tier and lifecycle
// status pushed from the account portal, an on-prem appliance reports its
// licence. The UI treats them the same.
//
// Fetched once per page load and shared, so putting the hook in several
// components costs one request.
let cached = null;
let cachedToken = null;

async function load() {
  const token = getMemberToken();
  if (cachedToken !== token) {
    cached = null;
    cachedToken = token;
  }
  if (!cached) {
    cached = memberApi("/admin/settings/licence").catch((e) => {
      cached = null; // let a later mount retry rather than caching a failure
      throw e;
    });
  }
  return cached;
}

export function resetEntitlementCache() {
  cached = null;
  cachedToken = null;
}

export function useEntitlement() {
  const [entitlement, setEntitlement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    load()
      .then((e) => {
        if (!cancelled) setEntitlement(e);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const hasFeature = (feature) => hasEntitledFeature(entitlement, feature);

  return {
    entitlement,
    loading,
    error,
    hasFeature,
    planTier: entitlement?.planTier ?? null,
    status: entitlement?.state ?? "active",
    suspended: entitlement?.state === "suspended",
    pastDue: entitlement?.state === "past_due",
  };
}
